import { faCircleCheck, faCircleX } from '@fortawesome/pro-duotone-svg-icons'

import customConfig from 'customConfig'
import { isMediaTypeImage } from './media.helpers'
import { NFT_BALANCES_SHOULD_FETCH_NFT_URL_PARAM } from '../constants/api'
import { NFT_EXCLUSIVE_CONTENT_STATUS } from '../constants/nft'

const getNftCoverImage = (metadata) => {
  const mediaType = metadata?.media?.type
  return mediaType && isMediaTypeImage(mediaType)
    ? metadata?.media?.url
    : metadata?.legacy?.coverImage
}

const buildStatusLabelIcon = (exclusiveContent, claimCount) => {
  if (exclusiveContent) {
    if (claimCount > 0) {
      return {
        label: NFT_EXCLUSIVE_CONTENT_STATUS.REDEEMED,
        icon: faCircleX
        // color: 'error'
      }
    } else {
      return {
        label: NFT_EXCLUSIVE_CONTENT_STATUS.AVAILABLE,
        icon: faCircleCheck
        // color: 'success'
      }
    }
  }
  return {
    label: '',
    icon: ''
  }
}

const extractNftReducer = (state) => state.value.nftReducer

const enforceShouldFetchNftUrlIfEligible = (state) => {
  if (customConfig.balancesAPIParams) {
    return customConfig.balancesAPIParams
  }
  const nftTokens = extractNftReducer(state).nftProfile.nftsForRedemption
  return nftTokens.some((token) => token?.metadata?.links?.exclusiveContentFile)
    ? NFT_BALANCES_SHOULD_FETCH_NFT_URL_PARAM
    : ''
}

const buildListNftForSaleData = (tokenId, brandId, nftId, usdPrice) => {
  return {
    order: {
      token_id: tokenId,
      brand_id: brandId,
      usd_price: usdPrice,
      type: 'sell',
      nft_id: nftId
    }
  }
}

export {
  getNftCoverImage,
  buildStatusLabelIcon,
  enforceShouldFetchNftUrlIfEligible,
  buildListNftForSaleData
}
